function initMarquee(speed, selector) {
  let slowSpeed = 0.1;
  // Ensure speed is a number
  speed = parseFloat(speed) || 1;
  let currentSpeed = speed;
  const clone = selector.innerHTML;
  selector.insertAdjacentHTML("beforeend", clone);
  selector.insertAdjacentHTML("beforeend", clone);

  const firstElement = selector.children[0];
  let i = 0;

  function animate() {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i += currentSpeed;
    requestAnimationFrame(animate);
  }
  animate();

  selector.addEventListener("mouseover", () => {
    currentSpeed = slowSpeed;
  });

  selector.addEventListener("mouseout", () => {
    currentSpeed = speed;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const marquees = document.querySelectorAll(".marquee-scroll-init");
  marquees.forEach((marquee) => {
    const speed = marquee.getAttribute("data-speed");
    initMarquee(speed, marquee);
  });
});



